<template>
  <el-header>
    <div class="header">
      <div>
        <div class="header_left">
          <div class="header_title">
            <a href="/" target="_blank">逸海定制选品</a>
          </div>
          <template v-for="(items, index) in navData" :key="index">
            <div class="header_title" v-if="items.to == '/'" :class="isHead == index ? 'header_hover' : ''"
              @click="headerMouseenter(index)">
              <router-link :to="items.to">{{ items.name }}</router-link>
            </div>
            <div class="header_title" v-else-if="items.href" :class="isHead == index ? 'header_hover' : ''"
              @click="headerMouseenter(index)">
              <a :href="items.href === 'ai_draw' ? AiDrawUrl : items.href" target="_blank">{{ items.name }}</a>
            </div>
            <div class="header_title" v-else-if="items.content" :class="isHead == index ? 'header_hover' : ''"
              @click="headerMouseenter(index)">
              {{ items.name }}
              <dl>
                <template v-for="(item, j) in items.content">
                  <dt v-if="item.header" :key="j">
                    <span v-for="(sp, i) in item.header" :key="i">{{
                      sp
                    }}</span>
                  </dt>
                  <dd v-if="item?.tabs?.length <= 5" :key="j">
                    <template v-for="(ite, i) in item.tabs">
                      <router-link v-if="ite.to" :to="ite.to" :key="i" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" :class="{ 'router-link-active': isRouteActive(ite.to) }">{{
                          ite.title
                        }}</a>
                      </router-link>
                      <a
                        v-else-if="ite.href"
                        :href="ite.href === 'ai_draw' ? AiDrawUrl : ite.href"
                        target="_blank"
                        :key="i + 1"
                      >
                        {{ ite.title }}
                      </a>
                      <img v-if="ite.title === '批量设计'"
                        :src="kefuce"
                        style="width: 32px; height: 16px; margin-left: -24px; margin-top: -5px; vertical-align: middle"
                       />
                       <img v-if="ite.title === '批量替换'"
                        :src="kefuce"
                        style="width: 32px; height: 16px; margin-left: -24px; margin-top: -5px; vertical-align: middle"
                       />
                       <img v-if="ite.title === '批量记录'"
                        :src="kefuce"
                        style="width: 32px; height: 16px; margin-left: -24px; margin-top: -5px; vertical-align: middle"
                       />
                      <!-- <a v-else-if="ite.href" :href="ite.href" target="_blank" :key="i + 1">{{ ite.title }}</a> -->
                      <a v-else-if="ite.html" v-html="ite.html" :key="i + 2"></a>
                    </template>
                  </dd>
                  <dd v-if="item?.tabs?.length > 5" :key="j + 1">
                    <template v-for="(ite, i) in item.tabs.slice(0, 5)">
                      <router-link v-if="ite.to" :to="ite.to" :key="i" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" :class="{ 'router-link-active': isRouteActive(ite.to) }">{{
                          ite.title
                        }}</a>
                      </router-link>
                     <a v-else-if="ite.href" :href="ite.href" target="_blank" :key="i + 1">{{ ite.title }}</a>
                      <a v-else-if="ite.html" v-html="ite.html" :key="i + 2"></a>
                    </template>
                  </dd>
                  <dd v-if="item?.tabs?.length > 5" :key="j + 1">
                    <template v-for="(ite, i) in item.tabs.slice(5)">
                      <router-link v-if="ite.to" :to="ite.to" :key="i" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" :class="{ 'router-link-active': isRouteActive(ite.to) }">{{
                          ite.title
                        }}</a>
                      </router-link>
                      <a v-else-if="ite.href" :href="ite.href" target="_blank" :key="i + 1">{{ ite.title }}</a>
                      <a v-else-if="ite.html" v-html="ite.html" :key="i + 2"></a>
                    </template>
                  </dd>
                </template>
              </dl>
            </div>
            <div class="header_title" v-else-if="items.to == '/mt' && Number(userInfo.group_id) == 3"
              :class="isHead == index ? 'header_hover' : ''" @click="headerMouseenter(index)">
              <router-link :to="items.to">{{ items.name }}</router-link>
            </div>
          </template>
          <div v-if="String(store.userInfo.group_id) === '3'" class="header_title">
            <a href="/mt/model/" target="_self">模特</a>
          </div>
        </div>
      </div>
      <div class="header_right">
        <div class="header_title">
          <el-popover :width="300"
            popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 10px;">
            <template #reference>
              <i class="nav_kefu zw_icon-icon_kefu"></i>
            </template>
            <template #default>
              <div class="demo-rich-conent" style="display: flex; gap: 6px; flex-direction: column">
                <img :src="kefuImg" />
              </div>
            </template>
          </el-popover>
        </div>
        <div class="header_title">
          <router-link to="/cart">
            <i class="iconfont" style="color: #fff">&#xe65e;</i>
          </router-link>
        </div>
        <!-- <div class="header_title">
          <i class="iconfont">&#xe8be;</i>
          <span class="notification-count" v-if="total_unread > 0">
            {{ total_unread >= 100 ? '99+' : total_unread }}
          </span>
          <div class="tongzhi" style="color: #000;">
            <div class="tongzhi-container">
                 <div class="tongzhi-header">
                    <div class="custom-tabs">
                        <div v-for="(category, index) in categoryList":key="category.category_id"
                           @click="handleTabChange(category.category_id)" :class="{ active: activeTabid === category.category_id }">
                           {{ category.category_name }}
                         </div>
                    </div>
                 </div>
                 <div class="tongzhi-content">
                  <div v-loading="loading" element-loading-text="加载中...">
                   <div v-if="messageListData.length > 0" v-for="item in messageListData" :key="item.id" class="message-item" @click="openDetailDrawer(item)"> 
                     <ul>
                        <li class="message-title" :class="{ 'unread': item.is_read === 1 }">
                          <div style="width: 70%;overflow: hidden;text-overflow: ellipsis; font-size: 1rem;">{{ item.title }}</div>
                          <div style="width: 30%;">{{ item.created_at }}</div>
                        </li>
                        <li class="message-description" :class="{ 'unread': item.is_read === 1 }">
                          <div style="width: 100%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ item.description }}</div>
                        </li>
                      </ul>
                    </div>
                    <div v-else class="empty-state">
                      <el-empty description="暂无数据" :image-size="100" />
                    </div>
                   </div>
                 </div>
            </div>
            <div class="tongzhi-footer">
             <a href="#notice" style="margin-left: 20px;">查看全部</a>
             <a href="#messageSubscription" style="margin-right: 20px">消息订阅管理</a>
            </div>
          </div>
        </div> -->
        <div class="header_title" @mouseenter="isHeaderUser = true" @mouseleave="isHeaderUser = false">
          <router-link :to="String(userInfo.guan_zhu_id) === '0' ? '/username' : {}">{{ userInfo.phone }}</router-link>
          <HeaderUser v-if="isHeaderUser" @showConfirm="showConfirm" />
        </div>
      </div>
    </div>
  </el-header>
  <Confirm ref="confirmRef" :data="data" @callback="loginOut" />
  <!-- 消息详情抽屉 -->
  <el-drawer
     v-model="detailDrawerVisible"
     size="35%"
     @close="onDrawerClose"
   >
     <template #header>
      <div class="drawer-title">{{ detailData?.title }}</div>
     </template>
        <div class="detail-meta">
           <span class="meta-item">消息类型: {{ detailData?.category_name}}</span>
           <span class="meta-item">发布时间: {{ detailData?.created_at}}</span>
        </div>
        <div class="content-wrapper" v-html="decodedContent" @click="handleContent"></div>
     <template #footer>
      <div class="detail-footer">
         <el-button @click="closeDrawer">关闭</el-button>
      </div>
     </template>
   </el-drawer>
   <!-- 添加的消息提示弹窗 -->
   <el-dialog v-model="dialogVisible" title="提示" width="40%" draggable>
    <template #header>
      <div class="drawer-title">
        {{ tipMessageListDatas?.title }}
      </div>
    </template>
    <div v-if="tipMessageListData?.length > 1" class="scroll-arrow left" @click="handlePrevClick"><</div>
    <div v-if="tipMessageListData?.length > 1" class="scroll-arrow right" @click="handleNextClick">></div>
    <div class="detail-meta">
      <span class="meta-item"
        >消息类型: {{ tipMessageListDatas?.category_name }}</span
      >
      <span class="meta-item"
        >发布时间: {{ tipMessageListDatas?.created_at }}</span
      >
    </div>
    <div class="message-content">
      <div class="content-wrapper" v-html="decodedTipMessageContent"  @click="handleContentClick"></div>
    </div>
    <template #footer>
      <div class="message-footer">
        <div>
          <el-checkbox
            v-model="noMoreTip"
            @change="handleNoMoreTipall(tipMessageListDatas?.id)"
            :disabled="noMoreTip"
          >
            不再接收该消息公告
          </el-checkbox>
        </div>
      </div>
      <div class="message-action">
        <div v-if="tipMessageListData?.length > 1" @click="dialogVisible = false">关闭所有弹框消息</div>
        <div v-else @click="dialogVisible = false">关闭弹框消息</div>
        <div v-if="tipMessageListData?.length > 1" @click="handleNextClick">
          下一条({{ currentIndex + 1 }}/{{ tipMessageListData?.length }})
        </div>
      </div>
    </template>
  </el-dialog>
  <el-image-viewer
    v-if="showImageViewer"
    :url-list="previewImageUrls"
    :initial-index="previewImageIndex"
    @close="showImageViewer = false"
  />
</template>
<script lang="ts" setup>
import { ref, onMounted ,onUnmounted } from "vue";
import Confirm from "./Confirm.vue";
import { deleteCookie } from "../utils/cookie";
import { useRouter, useRoute } from "vue-router";
import HeaderUser from "./Header/HeaderUser.vue";
import { useCounterStore } from "../store/userInfo";
import { storeToRefs } from "pinia";
import { parse } from 'cookie'
import kefuImg from "@/assets/images/kefu.jpg";
import kefuce from '@/assets/images/beta.png'
import { computed } from "vue";
import {unreadCount,messageList,messagedetail,tipMessageList,dontShowForever} from "@/service/api";
import { FormInstance, ElMessage, ElLoading } from "element-plus";
const store = useCounterStore();
const { userInfo } = storeToRefs(store);
const router = useRouter();
const route = useRoute();
const isHead = ref();
const confirmRef = ref();
const isMt = ref(false);
const aiToken=ref()
const aiSession=ref()
const recordUrl=ref()
//消息
const categoryList = ref<any[]>([]);
const activeTab = ref('1');
const activeTabid = ref('');
const messageListData = ref<any[]>([]);
const total = ref(0); 
const unread=ref(0)
const isMarked = ref(0);
const currentPage = ref(1);
const pageSize = ref(10);
const detailData = ref<any>(null);
const detailDrawerVisible = ref(false);
const loading = ref(false); 
const total_unread=ref(0)
const dialogVisible = ref(false)
const tipMessageListData = ref<any>([]); 
const noMoreTip = ref(false); 
const currentIndex = ref(0);
const tipMessageListDatas = ref<any>([]);
const noMoreTipStates = ref<{[key: string]: boolean}>({});
const showImageViewer = ref(false)
const previewImageUrls = ref<string[]>([])
const previewImageIndex = ref(0)
// al绘图跳转
const AiDrawUrl = computed(() => {
  let url = new URL('http://ai.mszxdz.com');
  let params = new URLSearchParams({token: aiToken.value, session: aiSession.value});
  url.search = params.toString();
  return url.href;
})
//批量合图记录跳转
const RecordUrl = computed(() => {
  return `http://mq.mszxdz.com/mq-monitor/${recordUrl.value}`;
})

const data = {
  title: "真的确定要登出吗?",
  width: "30%",
};

interface tabs {
  title: string;
  to?: string;
  is: boolean;
  href?: string;
  html?: string;
}

interface Content {
  header?: Array<string>;
  tabs: Array<tabs>;
}
interface NavData {
  name: string;
  to?: string;
  href?: string;
  content?: Array<Content>;
}

const navData = computed(() => [
  {
    name: "概览",
    to: "/",
  },
  {
    name: "素材图库",
    content: [
      {
        header: ["素材", "(传统电商-铺货模式)"],
        tabs: [
          //   {
          //   title: '官方素材',
          //   to: '/officialMaterial',
          //   is: true
          // },
          {
            title: "我的素材",
            to: "/myMaterial",
            is: true,
          },
          // {
          //   title: '我的定制素材',
          //   to: '/myCustomMaterial',
          //   is: true
          // },
          // {
          //   title: '共享素材库',
          //   to: '/shareMaterial',
          //   is: true
          // }
        ],
      },
      // {
      //   header: ['字体'],
      //   tabs: [
      //   {
      //     title: '自定义字体',
      //     to: '/customFont',
      //     is: true
      //   }]
      // }
    ],
  },
  {
    name: "选品/设计",
    content: [
      {
        header: ['选品/设计'],
        tabs: [
        // {
        //   title: '选品',
        //   // href: '/mt/design/',
        //   href: '/index.php?route=product/diy/prepare',
        //   is: true
        // },
        {
          title: '新设计',
          // href:'/mt/index.php?route=apipc/v1/diy/designsdk',
          href: '/index.php?route=apipc/v1/diy/designsdk',
          is: true
        },
        {
            title: '批量设计',
            href:"/index.php?route=apipc/v1/diy/batchEditor",
            is: true
        },
        {
            title: '批量替换',
            href:"/index.php?route=apipc/v1/diy/batchReplace&token=" + aiToken.value + "&session=" + aiSession.value,
            is: true
        },
        {
            title: '批量记录',
            href:"/index.php?route=apipc/v1/diy/batchRecord&token=" + aiToken.value + "&session=" + aiSession.value,
            is: true
        },
          // {
          //   title: '我的产品库（设计）',
          //   to: '/myProduct',
          //   is: true
          // },
          // {
          //   title: '特惠申请',
          //   href: '',
          //   is: true,
          //   html: `<el-popover
          //             placement="right-start"
          //             title="客服微信"
          //             :width="200"
          //             trigger="hover"
          //           >
          //             <span> Some content </span>
          //             <template #reference>
          //               特惠申请
          //             </template>
          //           </el-popover>`
          // }
        ]
      },
      // {
      //   header: ['产品相关工具'],
      //   tabs: [{
      //     title: '自定义报关信息',
      //     to: '/customsClearance',
      //     is: true
      //   },
      //   {
      //     title: '成本计算器',
      //     to: '/costCalculation',
      //     is: true
      //   },
      //   {
      //     title: '产品库子账号权限',
      //     to: '/childAccount',
      //     is: true
      //   }]
      // }
    ],
  },
  {
    name: "成品",
    content: [
      {
        header: ['成品'],

        tabs: [{
          title: '官方成品',
          to: '/officialFinished',
          is: true
        },
        {
          title: "我的成品",
          to: "/myFinished",
          is: true,
        },
        ],
      },

      // {
      //   tabs: [{
      //     title: '设计记录',
      //     to: '/designRecords',
      //     is: true
      //   }]
      // }
    ],
  },
  // {
  //   name: "AI",
  //   href: "ai_draw",
  // },
  {
    name: "刊登",
    content: [
      {
        header: ["刊登前准备"],
        tabs: [
          {
            title: "店铺管理",
            to: "/storeManagement",
            is: true,
          },
          // {
          //   title: "产品模板",
          //   to: "/productTemplate",
          //   is: true,
          // },
          // {
          //   title: "定价模板",
          //   to: "/pricingTemplate",
          //   is: true,
          // },
          // {
          //   title: "EAN/UPC管理",
          //   to: "/EANUPC",
          //   is: true,
          // },
        ],
      },
      // {
      //   header: ["刊登相关工具"],
      //   tabs: [
          // {
          //     title: '侵权资源处理',
          //     to: '/Infringement',
          //     is: true
          //   },
          //   {
          //     title: '自定义违禁词',
          //     to: '/bannedWord',
          //     is: true
          //   },
          //   {
          //     title: '水印设置',
          //     to: '/Watermark',
          //     is: true
          //   },
          //   {
          //     title: '图片独立域名',
          //     to: '/Image',
          //     is: true
          //   },
      //     {
      //       title: "自定义关键字",
      //       to: "/Keyword",
      //       is: true,
      //     },
      //     {
      //       title: "属性管理",
      //       to: "/propertyManagement",
      //       is: true,
      //     },
      //     {
      //       title: "产品标题模板",
      //       to: "/productTitleTemplate",
      //       is: true,
      //     },
      //     {
      //       title: "SKU规则",
      //       to: "/SKU",
      //       is: true,
      //     },
      //   ],
      // },
      {
        header: ["刊登产品"],
        tabs: [
          {
            title: "产品列表",
            to: "/asinProduct",
            is: true,
          }
        ],
      },
    ],
  },
  {
    name: "订单",
    content: [
      {
        header: ["订单"],
        tabs: [
          {
            title: '快速下单',
            to: '/quickOrder',
            is: true
          },
          {
            title: "购物车",
            to: "/Cart",
            is: true,
          },
          {
            title: "订单管理",
            to: "/orderManagement",
            is: true,
          },
          {
            title: "店铺管理",
            to: "/orderShopManagement",
            is: true,
          },
          // {
          //   title: '产品关联记录',
          //   to: '/productLinkRecord',
          //   is: true
          // },
          // {
          //   title: '素材订单',
          //   to: '/materialOrder',
          //   is: true
          // }
        ],
      },
      // {
      //   header: ['FBA'],
      //   tabs: [{
      //     title: 'FBA发货计划',
      //     to: '/fbaDelivery',
      //     is: true
      //   },
      //   {
      //     title: 'FBA线上补货',
      //     to: '/fbaFill',
      //     is: true
      //   }]
      // },
      // {
      //   header: ['售后'],
      //   tabs: [{
      //     title: 'FBA发货计划',
      //     to: '/fbaDelivery',
      //     is: true
      //   },
      //   {
      //     title: 'FBA线上补货',
      //     to: '/fbaFill',
      //     is: true
      //   }]
      // },
      // {
      //   header: ['设置'],
      //   tabs: [{
      //     title: '利润管理',
      //     to: '/profitManagement',
      //     is: true
      //   },
      //   {
      //     title: '黑名单',
      //     to: '/disabledList',
      //     is: true
      //   }]
      // }
    ],
  },
  {
    name: '统计',
    content: [
    {
        header: ["统计"],
        tabs: [{
          title: '销售概览',
          to: '/statistic?type=goods',
          is: true
        },
        {
          title: '下单统计',
          to: '/statistic?type=order',
          is: true
        },
       ]
      },
      // {
      //   tabs: [{
      //     title: '交易明细',
      //     to: '/tradingDetails',
      //     is: true
      //   }]
      // },
      // {
      //   tabs: [{
      //     title: '资源排行',
      //     to: '/resourcesRanking',
      //     is: true
      //   }]
      // }
    ]
  },
  // {
  //   name: '模特',
  //   to: '/mt'
  // },
]);

const isHeaderUser = ref(false);
function showConfirm() {
  if (confirmRef.value) confirmRef.value.show();
}
async function loginOut(s: any) {
  if (confirmRef.value) confirmRef.value.close();
  if (s.name == "confirm") {
    localStorage.removeItem("token");
    await store.login_out();
    // router.push({ name: "login" });
  }
}


//先让router.beforeEach函数里判断完queryToken，再执行下面的代码
const onLoadPage = async function () {
  let token = localStorage.getItem('token') || '';
  if (!token) {
    setTimeout(() => {
      Promise.all([store.getUserInfo(), store.getUserDetail()]).then(() => {
        aiToken.value=localStorage.getItem('token')
        aiSession.value=parse(document.cookie).OCSESSID
        recordUrl.value = userInfo.value.uid
      });
    }, 500);
  } else {
    await Promise.all([store.getUserInfo(), store.getUserDetail()]);
    aiToken.value=localStorage.getItem('token')
    aiSession.value=parse(document.cookie).OCSESSID
    recordUrl.value = userInfo.value.uid
    if (Number(store.userInfo.group_id) == 3) {
      isMt.value = true
    }
  }
};
onLoadPage();

function headerMouseenter(ind: number) {
  isHead.value = ind;
}

// 判断路由是否匹配
function isRouteActive(targetRoute: string): boolean {
  if (!targetRoute) return false;
  if (route.fullPath === targetRoute) return true;
  if (targetRoute.includes('?')) return false;
  return route.path === targetRoute;
}
router.afterEach((to, from, failure) => {
  if (!failure) {
    const path = to.path;
    const fullPath = to.fullPath; 
    navData.value.forEach((items, index) => {
      if (items.to == path) {
        isHead.value = index;
      } else if (items?.content) {
        items?.content.forEach((item) => {
          const tabs = item.tabs;
          tabs.forEach((itm) => {
            if (itm?.to && (itm.to === fullPath || itm.to === path)) {
              isHead.value = index;
            }
          });
        });
      }
    });
  }
});
// 获取分类列表
const unreadCountlist = async () => {
  const res = await unreadCount();
  if (res.code == 100) {
    categoryList.value = [
      {
        category_id: 0,
        category_name: "全部",
        short_name: "全部",
        unread_count: res.data.total_unread,
      },
      ...res.data.category_unread,
    ];
    total_unread.value=res.data.total_unread
    // 设置默认选中的标签
    if (categoryList.value.length > 0) {
      activeTab.value = categoryList.value[0].category_id.toString();
      activeTabid.value = categoryList.value[0].category_id;
      console.log(activeTab.value)
    }
  } else {
    ElMessage.error(res.msg);
  }
};
// 标签页切换
const handleTabChange = async(tabName: string) => {
  activeTabid.value = tabName;
  await messageListname();
};
//获取消息内容
const messageListname = async () => {
   // 显示全局loading
    loading.value = true;
    const res = await messageList({
      category_id: activeTabid.value,
      page: currentPage.value.toString(),
      page_size: pageSize.value.toString(),
    });
    messageListData.value = res.data.list;
    total.value = res.data.total;
    isMarked.value = res.data.unread;
    unread.value=res.data.unread
    if (res.code == 200) {
      ElMessage.error(res.msg);
    }
    loading.value = false;
};
//消息详情
const openDetailDrawer=async(item: any)=>{
  const res = await messagedetail({ id: item.id });
  if (res.code == 100) {
      detailData.value = res.data;
      detailDrawerVisible.value = true;
   } else {
      ElMessage.error(res.msg);
   }
}
// 关闭抽屉
const closeDrawer = () => {
  detailDrawerVisible.value = false;
  detailData.value = null;
};
// 抽屉关闭事件处理
const onDrawerClose = () => {
  messageListname();
  unreadCountlist()
  window.dispatchEvent(new CustomEvent('messageStatusChanged'));
};
// HTML 解码函数
const decodeHtml = (html: string): string => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

// 计算属性用于解码内容
const decodedContent = computed(() => {
  if (detailData.value && detailData.value.content) {
    return decodeHtml(detailData.value.content);
  }
  return '';
});
// 点击图片放大
const handleContent = event => {
  const target = event.target
  if (target.tagName === 'IMG') {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = decodedContent.value
    const images = tempDiv.querySelectorAll('img')
    previewImageUrls.value = Array.from(images).map(img => img.src)
    const clickedSrc = target.src
    previewImageIndex.value = Array.from(images).findIndex(img => img.src === clickedSrc)
    showImageViewer.value = true
  }
}
// 次刷新页面请求的全局弹窗消息
// const tipMessageLists = async () => {
//   const res = await tipMessageList();
//   if (res.code === 100) {
//     if (res.data.list.length > 0) {
//       dialogVisible.value = true;
//       tipMessageListData.value = res.data.list; 
//       console.log(tipMessageListData.value?.length)
//       currentIndex.value = 0; 
//       const detailRes = await messagedetail({ id: res.data.list[0].id });
//       tipMessageListDatas.value = detailRes.data; 
//       noMoreTip.value = noMoreTipStates.value[res.data.list[0].id] || false;
//     }
//   } else {
//     ElMessage.error(res.msg);
//   }
// };
// 上一条
const handlePrevClick = async () => {
  if (currentIndex.value <= 0) {
    ElMessage.warning("已经是第一条了");
    return;
  }
  currentIndex.value -= 1;
  const prevId = tipMessageListData.value[currentIndex.value].id;
  noMoreTip.value = noMoreTipStates.value[prevId] || false;
  const res = await messagedetail({ id: prevId });
  if (res.code === 100) {
    tipMessageListDatas.value = res.data;
  } else {
    ElMessage.error(res.msg);
  }
};
// 下一条
const handleNextClick = async () => {
  if (currentIndex.value >= tipMessageListData.value.length - 1) {
    ElMessage.warning("已经是最后一条了");
    return;
  }
  currentIndex.value += 1;
  const nextId = tipMessageListData.value[currentIndex.value].id;
  noMoreTip.value = noMoreTipStates.value[nextId] || false;
  const res = await messagedetail({ id: nextId });
  if (res.code === 100) {
    tipMessageListDatas.value = res.data;
  } else {
    ElMessage.error(res.msg);
  }
};
//  设置消息不再提醒
const handleNoMoreTipall = async (id:any) => {
  const res = await dontShowForever({ message_id: id });
  if(res.code==100){
    ElMessage.success(res.msg)
    if (id) {
      noMoreTipStates.value[id] = noMoreTip.value;
    }
  }else{
    ElMessage.error(res.msg)
  }
}
// 全局消息内容解析
const decodedTipMessageContent = computed(() => {
  if (tipMessageListDatas.value && tipMessageListDatas.value.content) {
    return decodeHtml(tipMessageListDatas.value.content);
  }
  return '';
});
// 全局弹框消息点击图片放大
const handleContentClick = event => {
  const target = event.target
  if (target.tagName === 'IMG') {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = decodedTipMessageContent.value
    const images = tempDiv.querySelectorAll('img')
    previewImageUrls.value = Array.from(images).map(img => img.src)
    const clickedSrc = target.src
    previewImageIndex.value = Array.from(images).findIndex(img => img.src === clickedSrc)
    showImageViewer.value = true
  }
}
// 新增：处理消息状态变化
const handleMessageStatusChange = () => {
  unreadCountlist();
  messageListname();
}
onUnmounted(() => {
  window.removeEventListener('messageStatusChanged', handleMessageStatusChange);
})
onMounted(()=>{
  unreadCountlist()
  messageListname()
  // tipMessageLists()
  window.addEventListener('messageStatusChanged', handleMessageStatusChange);
})
</script>
<style scoped>
.header {
  height: 60px;
  background-color: #007df2;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.header_left>div {
  padding: 0 24px;
}

.header_title {
  float: left;
  color: #fff;
  line-height: 60px;
  height: 60px;
  padding: 0 14px;
  font-size: 14px;
  position: relative;
}

.header_title:hover,
.header_hover {
  background-color: #1f96f8;
}

.header_title :deep(a) {
  color: #fff;
  font-size: 14px;
}

.header_title:hover dl {
  display: block;
}

.header_title dl {
  display: none;
  position: absolute;
  top: 60px;
  left: 0;
  max-width: 600px;
  padding-bottom: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.3);
  z-index: 999;
}

.header_title dt {
  height: 50px;
  line-height: 50px;
  white-space: nowrap;
  padding-right: 20px;
}

.header_title dl span:nth-of-type(1) {
  font-size: 14px;
  font-weight: 700;
  margin-left: 20px;
  color: black;
}

.header_title dl span:nth-of-type(2) {
  font-size: 12px;
  color: #9e9e9e;
}

.header_title dd {
  height: 42px;
  display: flex;
  white-space: nowrap;
}

.header_title dd a {
  font-size: 14px;
  line-height: 42px;
  color: #595959;
  display: inline-block;
  padding: 0 20px;
  vertical-align: top;
  transition: none;
  height: 100%;
  white-space: nowrap;
}

:deep(.header_title dd a.router-link-active) {
  cursor: pointer;
  color: #007df2;
}

.header_title dd a:hover {
  background-color: #007df2;
  color: #fff !important;
}

.header_title:hover .tongzhi {
  display: block;
}

.tongzhi {
  display: none;
  position: absolute;
  top: 60px;
  right: 0;
  width: 520px;
  height: 520px;
  background-color: #fff;
  box-shadow: 2px 0px 10px 0px rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.tongzhi a {
  font-size: 14px;
  color: #409EFF;
}
.tongzhi-container {
  width: 520px;
  height: 450px;
  border-bottom: 1px solid #e8e8e8;
}
.tongzhi-header {
  height: 75px;
  width: 100%;
}
.tongzhi-content {
  width: 100%;
  height: 375px;
  overflow-y: auto;
}
.tongzhi-content::-webkit-scrollbar {
  width: 4px;
}
.tongzhi-content::-webkit-scrollbar-thumb {
  background: #cacfd1;
  border-radius: 10px;
}
.tongzhi-footer {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 5px;
}
.custom-tabs {
  display: flex;
  gap: 20px;
  border-bottom: 1px solid rgba(5, 5, 5, 0.06);
}
.custom-tabs div {
  cursor: pointer;
  padding:5px 5px;
  margin-left: 22px;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  transition: all 0.2s ease;
}
.custom-tabs .active {
  color: #007df2;
  border-bottom: 2px solid #007df2;
}
.message-item {
  height: 100px;
  border-bottom: 1px solid rgba(5, 5, 5, 0.06);
  cursor: pointer;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  &:hover {
    background-color: #f5f7fa;
    transition: background-color 0.2s ease;
  }
}
.message-title {
  font-weight: bold;
  color: #303133;
  /* font-size: 1rem; */
  margin: 0;
  display: flex;
  justify-content: space-between;
  line-height: 1.4; 
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.message-description {
  color: #8c8989;
  font-size: 13px;
}
.message-title.unread,
.message-description.unread {
  color: #999999;
}
.notification-count {
  position: absolute;
  top: 12px;
  right: 3px;
  background-color: red;
  color: white;
  font-size: 12px;
  width: 22px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.drawer-title{
  font-weight: bold;
  font-size: 1.5rem;
  color: #333;
  margin: 0;
}
.detail-meta {
  display: flex;
  gap: 55px;
  margin-bottom: 10px;
  margin-top: 20px;
}
.meta-item {
  font-size: 14px;
  color: #999999;
  padding: 2px 0; 
}
.message-content {
  width: 100%;
  height: 350px;
  overflow-y: auto;
  padding: 10px;
}
.message-content::-webkit-scrollbar {
  width: 6px;
}
.message-content::-webkit-scrollbar-thumb {
  background-color: #fff;
  border-radius: 3px;
}
.message-footer {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
}
.message-action{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  line-height: 50px;
}
.scroll-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  font-weight: bold;
  font-size: 50px;
  color: #000;
}

.scroll-arrow.left {
  left: -40px;
}

.scroll-arrow.right {
  right: -40px;
}
.content-wrapper{
  cursor: pointer;
}
</style>
